import { IParamsGetJobs, IPayloadAddJob, IPayloadUpdateJob, IResponseGetBoardCount, IResponseGetJobs, IJobUploadFile, IParamsGetJobPhotos } from '~/utils/interface/job';
import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import { urlApiJobs } from '~/utils/constants/apis';



const dashboardApi = {
    getTop() {
        return axiosClient.get<IApiBaseResponse<IResponseGetJobs>>(`/api/dashboard/top`);
    },

    getJobMonthly(params:any) {
        return axiosClient.get<IApiBaseResponse<IResponseGetJobs>>(`/api/dashboard/jobs-monthly`,{params});
    },

    getOverview(params:any) {
        return axiosClient.get<IApiBaseResponse<IResponseGetJobs>>(`/api/dashboard/project-overview`,{params});
    },

    getProjectRevenue(params:any) {
        return axiosClient.get<IApiBaseResponse<IResponseGetJobs>>(`/api/dashboard/project-revenue`, {params});
    }
};

export default dashboardApi;
